export const ReleaseTagPreferredOrder = [
  'preview',
  'lts-1',
  'stable-2',
  'production',
  'beta',
  'development',
  'valor',
];
